var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex flex-row align-items-center"},[_c('hundred-slider',{attrs:{"color":_vm.color,"hideNumbers":true,"marks":[
				0,
				'Not at all like me',
				10,
				'Not much like me',
				30,
				'Somewhat unlike me',
				50,
				'Somewhat like me',
				70,
				'Much like me',
				90,
				'Very much like me',
				100,
				20,
				40,
				60,
				80 ]},model:{value:(_vm.value.score),callback:function ($$v) {_vm.$set(_vm.value, "score", $$v)},expression:"value.score"}})],1),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.value.reasoning),expression:"value.reasoning"}],staticClass:"form-control flex-grow mt-3 text-md",attrs:{"rows":"5","placeholder":"Explanation of rating..."},domProps:{"value":(_vm.value.reasoning)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.value, "reasoning", $event.target.value)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }